import React from 'react'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { useLanguage } from '~/hooks'

export default function DifferentialsSVG() {
  const breakpoints = useBreakpoint()
  const { t } = useLanguage()

  return breakpoints.xs ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="325.143"
      height="632.402"
      viewBox="0 0 325.143 632.402"
    >
      <g transform="translate(325.143) rotate(90)">
        <g
          transform="translate(20 20.152)"
          fill="none"
          stroke="#1d1d1b"
          strokeWidth="2"
        >
          <rect width="592.402" height="284.99" stroke="none" />
          <rect x="1" y="1" width="590.402" height="282.99" fill="none" />
        </g>
        <g
          transform="translate(50 50.01)"
          fill="none"
          stroke="#1d1d1b"
          strokeWidth="2"
        >
          <rect width="95" height="224.99" stroke="none" />
          <rect x="1" y="1" width="93" height="222.99" fill="none" />
        </g>
        <rect
          width="40"
          height="40"
          transform="translate(131.281 285.143)"
          fill="#edf0e8"
        />
        <path
          d="M6.809.191,0,7,6.809.191,6.619,0l.191.191L7,0,6.809.191,13.619,7Z"
          transform="translate(142.658 311.598) rotate(-90)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
        <rect
          width="40"
          height="40"
          transform="translate(296.178 285.143)"
          fill="#edf0e8"
        />
        <path
          d="M6.809.191,0,7,6.809.191,6.619,0l.191.191L7,0,6.809.191,13.619,7Z"
          transform="translate(312.445 311.598) rotate(-90)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
        <rect
          width="40"
          height="40"
          transform="translate(461.075 285.143)"
          fill="#edf0e8"
        />
        <path
          d="M6.809.191,0,7,6.809.191,6.619,0l.191.191L7,0,6.809.191,13.619,7Z"
          transform="translate(482.232 311.598) rotate(-90)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
        <rect
          width="40"
          height="40"
          transform="translate(461.075 0.152)"
          fill="#edf0e8"
        />
        <path
          d="M6.809,6.809,0,0,6.809,6.809,6.619,7l.191-.191L7,7l-.191-.191L13.619,0Z"
          transform="translate(482.7 26.607) rotate(-90)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
        <rect
          width="40"
          height="40"
          transform="translate(296.178 0.152)"
          fill="#edf0e8"
        />
        <path
          d="M6.809,6.809,0,0,6.809,6.809,6.619,7l.191-.191L7,7l-.191-.191L13.619,0Z"
          transform="translate(312.913 26.607) rotate(-90)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
        <rect
          width="40"
          height="40"
          transform="translate(131.281 0.152)"
          fill="#edf0e8"
        />
        <path
          d="M6.809,6.809,0,0,6.809,6.809,6.619,7l.191-.191L7,7l-.191-.191L13.619,0Z"
          transform="translate(143.126 26.607) rotate(-90)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
        <rect
          width="40"
          height="40"
          transform="translate(632.402 144.133) rotate(90)"
          fill="#edf0e8"
        />
        <path
          d="M6.809,6.809,0,0,6.809,6.809,6.619,7l.191-.191L7,7l-.191-.191L13.619,0Z"
          transform="translate(605.947 161.293)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
        <rect
          width="40"
          height="40"
          transform="translate(0 184.133) rotate(-90)"
          fill="#edf0e8"
        />
        <path
          d="M6.809.191,0,7,6.809.191,6.619,0l.191.191L7,0,6.809.191,13.619,7Z"
          transform="translate(13.545 159.8)"
          fill="none"
          stroke="#000"
          strokeWidth="2"
        />
        <g
          transform="translate(164 50.01)"
          fill="none"
          stroke="#1d1d1b"
          strokeWidth="2"
        >
          <rect width="90" height="224.99" stroke="none" />
          <rect x="1" y="1" width="88" height="222.99" fill="none" />
        </g>
        <g
          transform="translate(273.999 50.01)"
          fill="none"
          stroke="#1d1d1b"
          strokeWidth="2"
        >
          <rect width="90" height="224.99" stroke="none" />
          <rect x="1" y="1" width="88" height="222.99" fill="none" />
        </g>
        <g
          transform="translate(383 50.01)"
          fill="none"
          stroke="#1d1d1b"
          strokeWidth="2"
        >
          <rect width="90" height="224.99" stroke="none" />
          <rect x="1" y="1" width="88" height="222.99" fill="none" />
        </g>
        <g
          transform="translate(492 50.01)"
          fill="none"
          stroke="#1d1d1b"
          strokeWidth="2"
        >
          <rect width="90" height="224.99" stroke="none" />
          <rect x="1" y="1" width="88" height="222.99" fill="none" />
        </g>
        <text
          id="Aumento_da_qualidade_do_produto_entregue."
          data-name={t('DifferentialsSVG.increaseProductQuality')}
          transform="translate(75.748 252.99) rotate(-90)"
          fill="#1d1d1b"
          fontSize="16"
          fontFamily="Avenir Roman, Avenir"
        >
          <tspan x="0" y="19">
            {t('DifferentialsSVG.IncreaseDeliveredProduct.1')}{' '}
          </tspan>
          <tspan x="0" y="37">
            {t('DifferentialsSVG.IncreaseDeliveredProduct.2')}
          </tspan>
        </text>
        <text
          id="Redução_de_incompatibilidade_e_interferências_no_projeto."
          data-name={t('DifferentialsSVG.reduceIncompatibility.2')}
          transform="translate(178 252.99) rotate(-90)"
          fill="#1d1d1b"
          fontSize="16"
          fontFamily="Avenir Roman, Avenir"
        >
          <tspan x="0" y="19">
            {t('DifferentialsSVG.reductionIncompatibility.1')}{' '}
          </tspan>
          <tspan x="0" y="37">
            {t('DifferentialsSVG.reductionIncompatibility.2')}{' '}
          </tspan>
          <tspan x="0" y="55">
            {t('DifferentialsSVG.reductionIncompatibility.3')}
          </tspan>
        </text>
        <text
          transform="translate(296.998 252.99) rotate(-90)"
          fill="#1d1d1b"
          fontSize="16"
          fontFamily="Avenir Roman, Avenir"
        >
          <tspan x="0" y="19">
            {t('DifferentialsSVG.increaseProductivity.1')}{' '}
          </tspan>
          <tspan x="0" y="37">
            {t('DifferentialsSVG.increaseProductivity.2')}
          </tspan>
        </text>
        <text
          id="Melhor_entendimento_e_visualização_dos_espaços_entregues_desde_a_fase_de_projeto."
          data-name={t('DifferentialsSVG.improveUnderstanding')}
          transform="translate(385.748 252.99) rotate(-90)"
          fill="#1d1d1b"
          fontSize="16"
          fontFamily="Avenir Roman, Avenir"
        >
          <tspan x="0" y="19">
            {t('DifferentialsSVG.bestView.1')}{' '}
          </tspan>
          <tspan x="0" y="37">
            {t('DifferentialsSVG.bestView.2')}{' '}
          </tspan>
          <tspan x="0" y="55">
            {t('DifferentialsSVG.bestView.3')}{' '}
          </tspan>
          <tspan x="0" y="73">
            {t('DifferentialsSVG.bestView.4')}
          </tspan>
        </text>
        <text
          id="Realidade_virtual_e_Realidade_aumentada_melhorando_a_experiência_do_cliente."
          data-name={t('DifferentialsSVG.virtualReality')}
          transform="translate(496.748 252.5) rotate(-90)"
          fill="#1d1d1b"
          fontSize="16"
          fontFamily="Avenir Roman, Avenir"
        >
          <tspan x="0" y="19">
            {t('DifferentialsSVG.virtualRealityExperience.1')}{' '}
          </tspan>
          <tspan x="0" y="37">
            {t('DifferentialsSVG.virtualRealityExperience.2')}{' '}
          </tspan>
          <tspan x="0" y="55">
            {t('DifferentialsSVG.virtualRealityExperience.3')}{' '}
          </tspan>
          <tspan x="0" y="73">
            {t('DifferentialsSVG.virtualRealityExperience.4')}.
          </tspan>
        </text>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1344"
      height="220"
      viewBox="0 0 1344 220"
    >
      <g transform="translate(20 20)" fill="none" stroke="#000" strokeWidth="1">
        <rect width="1304" height="180" stroke="none" />
        <rect x="0.5" y="0.5" width="1303" height="179" fill="none" />
      </g>
      <g transform="translate(50 50)" fill="none" stroke="#000" strokeWidth="1">
        <rect width="233" height="120" stroke="none" />
        <rect x="0.5" y="0.5" width="232" height="119" fill="none" />
      </g>
      <g
        transform="translate(303 50)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="233" height="120" stroke="none" />
        <rect x="0.5" y="0.5" width="232" height="119" fill="none" />
      </g>
      <g
        transform="translate(556 50)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="233" height="120" stroke="none" />
        <rect x="0.5" y="0.5" width="232" height="119" fill="none" />
      </g>
      <g
        transform="translate(809 50)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="233" height="120" stroke="none" />
        <rect x="0.5" y="0.5" width="232" height="119" fill="none" />
      </g>
      <g
        transform="translate(1062 50)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="233" height="120" stroke="none" />
        <rect x="0.5" y="0.5" width="232" height="119" fill="none" />
      </g>
      <text
        transform="translate(70 68.506)"
        fill="#1d1d1b"
        fontSize="16"
        fontFamily="Avenir Roman, Avenir"
      >
        <tspan x="0" y="16">
          {t('DifferentialsSVG.IncreaseDeliveredProduct.1')}{' '}
        </tspan>
        <tspan x="0" y="34">
          {t('DifferentialsSVG.IncreaseDeliveredProduct.2')}
        </tspan>
      </text>
      <text
        transform="translate(323 68.506)"
        fill="#1d1d1b"
        fontSize="16"
        fontFamily="Avenir Roman, Avenir"
      >
        <tspan x="0" y="16">
          {t('DifferentialsSVG.reductionIncompatibility.1')}{' '}
        </tspan>
        <tspan x="0" y="34">
          {t('DifferentialsSVG.reductionIncompatibility.2')}{' '}
        </tspan>
        <tspan x="0" y="52">
          {t('DifferentialsSVG.reductionIncompatibility.3')}
        </tspan>
      </text>
      <text
        transform="translate(576 68.506)"
        fill="#1d1d1b"
        fontSize="16"
        fontFamily="Avenir Roman, Avenir"
      >
        <tspan x="0" y="16">
          {t('DifferentialsSVG.increaseProductivityMob.1')}{' '}
        </tspan>
        <tspan x="0" y="34">
          {t('DifferentialsSVG.increaseProductivityMob.2')}{' '}
        </tspan>
        <tspan x="0" y="52">
          {t('DifferentialsSVG.increaseProductivityMob.3')}
        </tspan>
      </text>
      <text
        transform="translate(829 68.506)"
        fill="#1d1d1b"
        fontSize="16"
        fontFamily="Avenir Roman, Avenir"
      >
        <tspan x="0" y="16">
          {t('DifferentialsSVG.bestView.1')}{' '}
        </tspan>
        <tspan x="0" y="34">
          {t('DifferentialsSVG.bestView.2')}{' '}
        </tspan>
        <tspan x="0" y="52">
          {t('DifferentialsSVG.bestView.3')}{' '}
        </tspan>
        <tspan x="0" y="70">
          {t('DifferentialsSVG.bestView.4')}
        </tspan>
      </text>
      <text
        transform="translate(1082 68.506)"
        fill="#1d1d1b"
        fontSize="16"
        fontFamily="Avenir Roman, Avenir"
      >
        <tspan x="0" y="16">
          {t('DifferentialsSVG.virtualRealityExperienceMob.1')}{' '}
        </tspan>
        <tspan x="0" y="34">
          {t('DifferentialsSVG.virtualRealityExperienceMob.2')}{' '}
        </tspan>
        <tspan x="0" y="52">
          {t('DifferentialsSVG.virtualRealityExperienceMob.3')}{' '}
        </tspan>
        <tspan x="0" y="70">
          {t('DifferentialsSVG.virtualRealityExperienceMob.4')}
        </tspan>
      </text>
      <g
        transform="translate(289 180)"
        fill="#edf0e8"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <path
        d="M6.809.191,0,7,6.809.191,6.619,0l.191.191L7,0,6.809.191,13.619,7Z"
        transform="translate(305 206.455) rotate(-90)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
      <g
        transform="translate(652 180)"
        fill="#edf0e8"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <path
        d="M6.809.191,0,7,6.809.191,6.619,0l.191.191L7,0,6.809.191,13.619,7Z"
        transform="translate(668 206.455) rotate(-90)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
      <g
        transform="translate(1015 180)"
        fill="#edf0e8"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <path
        d="M6.809.191,0,7,6.809.191,6.619,0l.191.191L7,0,6.809.191,13.619,7Z"
        transform="translate(1031 206.455) rotate(-90)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
      <g
        transform="translate(1015)"
        fill="#edf0e8"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <path
        d="M6.809,6.809,0,0,6.809,6.809,6.619,7l.191-.191L7,7l-.191-.191L13.619,0Z"
        transform="translate(1032 26.455) rotate(-90)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
      <g
        transform="translate(652)"
        fill="#edf0e8"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <path
        d="M6.809,6.809,0,0,6.809,6.809,6.619,7l.191-.191L7,7l-.191-.191L13.619,0Z"
        transform="translate(669 26.455) rotate(-90)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
      <g
        transform="translate(289)"
        fill="#edf0e8"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <path
        d="M6.809,6.809,0,0,6.809,6.809,6.619,7l.191-.191L7,7l-.191-.191L13.619,0Z"
        transform="translate(306 26.455) rotate(-90)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
      <g
        transform="translate(1344 91) rotate(90)"
        fill="#edf0e8"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <path
        d="M6.809,6.809,0,0,6.809,6.809,6.619,7l.191-.191L7,7l-.191-.191L13.619,0Z"
        transform="translate(1317.545 108)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
      <g
        transform="translate(0 131) rotate(-90)"
        fill="#edf0e8"
        stroke="#000"
        strokeWidth="1"
      >
        <rect width="40" height="40" stroke="none" />
        <rect x="0.5" y="0.5" width="39" height="39" fill="none" />
      </g>
      <path
        d="M6.809.191,0,7,6.809.191,6.619,0l.191.191L7,0,6.809.191,13.619,7Z"
        transform="translate(13.545 107)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
    </svg>
  )
}
